<template>
    <div>
        <img :src="require('@/assets/images/gamas/66/pared.png')"
            style="transform: rotate(90deg)" />
    </div>
</template>
<script>
import editParameterValueComponent from "./../editParameterValue.vue";

export default {
    name: 'mainElement68techoDiagramaComponent',

    props: {
        mainElement: {
            type: Object,
            required: true
        }
    },

    components: {
        editParameterValueComponent
    }
}
</script>